import { render, staticRenderFns } from "./BulletBox.vue?vue&type=template&id=5937ebee&scoped=true"
import script from "./BulletBox.vue?vue&type=script&lang=js"
export * from "./BulletBox.vue?vue&type=script&lang=js"
import style0 from "./BulletBox.vue?vue&type=style&index=0&id=5937ebee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937ebee",
  null
  
)

export default component.exports